import application from 'application/application';

application.directive('ngTooltipEllipsis', [
	'$timeout',
	$timeout => ({
		restrict: 'A',
		link(scope, element) {
			let updateScheduled = false;
			let resizeObserver = null;
			let observedMeasurementElement = null;

			const getMeasurementElement = () =>
				element[0].querySelector('.alert-message-text-content') || element[0];

			const getAlertMessageElement = () => {
				let current = element[0];

				while (current && current !== document.body) {
					if (
						current.classList &&
						current.classList.contains('alert-message')
					) {
						return current;
					}

					current = current.parentElement;
				}

				return null;
			};

			const isElementVisible = target =>
				!!target &&
				target.offsetParent !== null &&
				window.getComputedStyle(target).display !== 'none';

			const updateTooltipState = () => {
				const alertMessageElement = getAlertMessageElement();
				const measurementElement = getMeasurementElement();
				const isVisible =
					isElementVisible(element[0]) &&
					isElementVisible(alertMessageElement) &&
					isElementVisible(measurementElement);
				const hasEllipsisActive =
					isVisible &&
					measurementElement.scrollWidth > measurementElement.clientWidth + 1;

				element.attr('ng-tooltip-hide', hasEllipsisActive ? 'false' : 'true');
			};

			const scheduleUpdate = () => {
				if (updateScheduled) {
					return;
				}

				if (resizeObserver) {
					const measurementElement = getMeasurementElement();

					if (
						measurementElement &&
						measurementElement !== observedMeasurementElement
					) {
						if (observedMeasurementElement) {
							resizeObserver.unobserve(observedMeasurementElement);
						}

						resizeObserver.observe(measurementElement);
						observedMeasurementElement = measurementElement;
					}
				}

				updateScheduled = true;

				$timeout(() => {
					updateScheduled = false;
					updateTooltipState();
				}, 0, false);
			};

			const unwatchTextContent = scope.$watch(
				() => getMeasurementElement().textContent,
				scheduleUpdate
			);

			const unwatchAlertClass = scope.$watch(
				() => {
					const alertMessageElement = getAlertMessageElement();

					return alertMessageElement ? alertMessageElement.className : '';
				},
				scheduleUpdate
			);

			const alertMessageElement = getAlertMessageElement();
			let alertMessageObserver = null;

			if (window.MutationObserver && alertMessageElement) {
				alertMessageObserver = new window.MutationObserver(scheduleUpdate);
				alertMessageObserver.observe(alertMessageElement, {
					attributes: true,
					attributeFilter: ['class', 'style']
				});
			}

			if (window.ResizeObserver) {
				resizeObserver = new window.ResizeObserver(scheduleUpdate);
				resizeObserver.observe(element[0]);

				if (alertMessageElement) {
					resizeObserver.observe(alertMessageElement);
				}

				observedMeasurementElement = getMeasurementElement();
				if (observedMeasurementElement) {
					resizeObserver.observe(observedMeasurementElement);
				}
			}

			window.addEventListener('resize', scheduleUpdate);
			scheduleUpdate();
			$timeout(scheduleUpdate, 100, false);

			scope.$on('$destroy', () => {
				unwatchTextContent();
				unwatchAlertClass();

				window.removeEventListener('resize', scheduleUpdate);

				if (alertMessageObserver) {
					alertMessageObserver.disconnect();
				}

				if (resizeObserver) {
					resizeObserver.disconnect();
				}
			});
		}
	})
]);
